/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

export function InformationModal({ closeModal }) {
  return (
    <div className="content-backdrop content-backdrop--show">
      <div className="content-backdrop__content">
        <div className="data-container py-5 px-3 px-lg-5 text-center">
          <h3 className="heading-h3 heading-lg-h2 mb-2">Höjdpunkter</h3>
          <p className="text-regular mb-4">
            För att ta del av höjdpunkter behöver du logga in
          </p>
          <a className="button button--primary-blue" href="/auth/login">
            Logga In
          </a>
        </div>
        <div onClick={closeModal} className="content-backdrop__close">
          ✕
        </div>
      </div>
    </div>
  );
}
